<script lang="ts">
  import type { PageContent } from '$lib/def/seo/page';

	export let index: number;
	export let content: PageContent;

	const editHref = async (prop: string) => {
		return {}
	}
</script>

<!-- TODO @Gareth: I added a silly if block to remove warnings (Dan) -->
{#if true}
	{@const _only_to_remove_check_warnings = index}
	{@const __only_to_remove_check_warnings = content}

	<!-- TODO: add button to DELETE a block - done by setting `block-[index]-type` to 'hidden' -->
	<div class='m-auto'>
		<slot/>
	</div>
{/if}

